const RU_COUNTRIES = new Set([
  "ru",
  "rus",
  "russia",
  "russian federation",
  "россия",
  "российская федерация",
]);

export const getEventCurrency = (event) => {
  const explicit = String(
    event?.currency ||
      event?.participant_ticketing?.currency ||
      event?.ticket_purchase_preview?.currency ||
      ""
  ).trim().toUpperCase();
  if (explicit) return explicit;
  return RU_COUNTRIES.has(String(event?.country || "").trim().toLowerCase()) ? "RUB" : "EUR";
};

export const formatEventMoney = (value, event, locale = "en-GB") => {
  const numeric = Number.parseFloat(String(value ?? "").replace(",", "."));
  if (!Number.isFinite(numeric)) return "";
  const currency = getEventCurrency(event);
  try {
    const formatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: Number.isInteger(numeric) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(numeric);
    if (currency === "EUR") return `${formatted} €`;
    if (currency === "RUB") return `${formatted} ₽`;
    return `${formatted} ${currency}`;
  } catch {
    return `${numeric.toFixed(Number.isInteger(numeric) ? 0 : 2)} ${currency}`;
  }
};
